export default __webpack_public_path__ + "static/media/interrior.a9f9cad9.svg";